// src/config/envio.js
// Configuraciones específicas para el sistema de envío por bultos

// Toggle principal - si es false, todo funciona como antes (precio fijo por área)
// Si es true, el precio del área se multiplica por la cantidad de bultos
export const ENVIO_POR_BULTOS_HABILITADO = false

// Colores para cada categoría de tamaño (para badges, etc.)
export const CATEGORIAS_TAMANO_COLORES = {
	PPP: '#17a2b8', // celeste - Extra Extra Pequeño
	PP: '#20c997',  // verde claro - Extra Pequeño
	P: '#28a745',   // verde - Pequeño
	M: '#ffc107',   // amarillo - Mediano
	G: '#dc3545',   // rojo - Grande
	GG: '#c71585',  // rosa fuerte - Extra Grande
	GGG: '#6f42c1'  // violeta - Extra Extra Grande
}

// Opciones para el selector de categoría en productos
export const OPCIONES_CATEGORIA_TAMANO = [
	{ value: '', label: 'Sin categoría (1 bulto por unidad)' },
	{ value: 'PPP', label: 'Extra Extra Pequeño' },
	{ value: 'PP', label: 'Extra Pequeño' },
	{ value: 'P', label: 'Pequeño' },
	{ value: 'M', label: 'Mediano' },
	{ value: 'G', label: 'Grande' },
	{ value: 'GG', label: 'Extra Grande' },
	{ value: 'GGG', label: 'Extra Extra Grande' }
]
